<script>
  import { onMount } from "svelte";
  import Filters from "./Filters.svelte";
  import Variation from "./Variation.svelte";
  import Spinner from "./Spinner.svelte";
  import TickIcon from "./TickIcon.svelte";
  export let variations;
  export let textVars;
  export let activeColumns;
  export let columnsOrder;
  export let showFilters;
  export let attributes;
  export let sortKey;
  export let imageURL;
  export let showSpinner;
  export let defaultInputQty;
  export let layoutType;
  export let showAddToEnquiry;
  export let showAddToCart;
  export let multiAddNonce;
  export let CewB2B;
  const CEW_VARIATIONS_TABLE_LAYOUT_BUTTONS_PER_ROW = 1;
  const CEW_VARIATIONS_TABLE_LAYOUT_BUTTONS_SINGLE = 2;
  let filters = [];
  let activeFilters = [];
  let searchQuery = "";

  let multiAddToCartBtn;
  let multiAddToEnquiryBtn;
  let added = false;
  let loading = false;
  let loadingEnquiry = false;
  let loadingCart = false;
  let showTestBtn = false;

  onMount(async () => {
    for (let i = 0; i < Object.keys(attributes).length; i++) {
      activeFilters.push("");
    }
  });

  if(!columnsOrder){
    columnsOrder = {}
  }

  let columnsTypes = {
    image_link: 'image',
    sku: 'text',
    variation_description: 'html',
    weight_html: 'html',
    dimensions_html: 'html',
    attributes: 'array',
    availability_html: 'stock',
    price_html: 'html',
    quantity: 'text'
  }

  let sortOrders = {};
  let columns = [];
  for (const key in columnsOrder) {
    if (columnsOrder.hasOwnProperty(key)) {
      columns.push({
        key: columnsOrder[key],
        title: textVars.columnsText[columnsOrder[key]] || '',
        type: columnsTypes[columnsOrder[key]],
        active: activeColumns[columnsOrder[key]]
      })
    }
  }

  let columnsOrderValues = Object.values(columnsOrder)

  for (const key in activeColumns) {
    if (activeColumns.hasOwnProperty(key)) {
      if(columnsOrderValues.includes(key))
        continue;
      columns.push({
        key,
        title: textVars.columnsText[key] || '',
        type: columnsTypes[key],
        active: activeColumns[key]
      })
    }
  }

  function calcColumns() {
    let columnsNum = 1;
    columns.forEach(col => {
      if (activeColumns[col.key]) {
        columnsNum++;
      }
    });
    if(activeColumns.attributes){
      columnsNum += Object.keys(attributes).length -1
    }
    return columnsNum;
  }
  let activeColumnsNum = calcColumns();
  function sortBy(key) {
    if (key === "image_link") return;
    sortKey = key;
    if (sortOrders[key] === undefined) {
      sortOrders[key] = 1;
    } else {
      sortOrders[key] = sortOrders[key] * -1;
    }
    filteredData = filterData();
  }

  function filterFunction(item) {
    var ok = 0;
    for (let i = 0; i < filters.length; i++) {
      let filterKey = Object.keys(filters[i])[0];
      if (!item["attributes"][filterKey]) return false;
      if (item["attributes"][filterKey] === filters[i][filterKey]) {
        ok++;
      }
    }
    if (ok === filters.length) {
      return true;
    }
    return false;
  }

  function filterData() {
    let filterKey = searchQuery && searchQuery.toLowerCase();
    let order = sortOrders[sortKey] || 1;
    let data = variations;

    if (filterKey) {
      data = variations.filter(function(row) {
        return Object.keys(row).some(function(key) {
          return (
            String(row[key])
              .toLowerCase()
              .indexOf(filterKey) > -1
          );
        });
      });
    }
    if (filters && filters.length) {
      data = data.filter(filterFunction);
    }
    if (sortKey) {
      data = data.slice().sort(function(a, b) {
        if (sortKey.startsWith("attribute_")) {
          a = a.attributes[sortKey];
          b = b.attributes[sortKey];
        } else {
          a = a[sortKey];
          b = b[sortKey];
        }
        return (a === b ? 0 : a > b ? 1 : -1) * order;
      });
    }
    return data;
  }
  let filteredData = filterData();
  function setFilters(event) {
    filters = event.detail;
    filteredData = filterData();
  }

  function multiAddToCart() {
    loadingCart = true;
    multiAddAction('multi_add_cart');
  }
  function multiAddToEnquiry() {
    loadingEnquiry = true;
    multiAddAction('multi_add_enquiry');
  }

  function multiAddAction( actionType ) {
    let enquiryData = { action: 'cewat_multi_action', cewat_nonce: multiAddNonce, cewat_action: actionType };
    let variationsData = [];
    let productId = 0;

    // Get rows with quantity more than 0
    jQuery('#variations-table .qty').each(function(){

      let qty = jQuery(this).val();
      productId = jQuery(this).data('product_id');

      if (qty > 0) {
        let variationId = jQuery(this).data('variation_id');
        let rowData = { id: variationId, qty: qty };

        // Get parent row to get the attributes
        var parentRow = jQuery(this).closest('tr');

        if (parentRow) {
          var attributes = jQuery(parentRow).data();

          for(var attributeKey in attributes) {
            if (attributeKey.indexOf('attribute_') != -1) {
              rowData[attributeKey] = attributes[attributeKey];
            }
          }

        }

        variationsData.push(rowData);
      }
    });

    if (variationsData.length <= 0) {

      let buttons = {
        ok: {
          text: 'Ok'
        },
      };

      showDialog('Error', 'Please add at least 1 quantity', 'error', buttons );

      // Nothing to add, exit
      loading = false;
      loadingCart = false;
      loadingEnquiry = false;
      return false;
    }

    loading = true;
    enquiryData.variations = variationsData;
    enquiryData.product_id = productId;
    //console.log(variationsData);

    jQuery.ajax({
      type: 'POST',
      url: CewB2B.ajaxurl,
      dataType: 'json',
      data: enquiryData,
      success: function (response) {

        loading = false;
        loadingCart = false;
        loadingEnquiry = false;
        let title = (CewB2B.popup_label_info) ? CewB2B.popup_label_info : 'Info';
        let alertType = 'green';
        let labelOk = (response.label_ok) ? response.label_ok : 'Ok';

        let buttons = {
          ok: {
            text: labelOk
          },
          viewEnquiry: {
            text: response.label_view,
            action: function () {
              window.location.href = response.view_url;
            }
          }
        };

        if (response.result == true) {
          alertType = 'success';

          if ( actionType == 'multi_add_enquiry' ) {
            updateEnquiryCartBadgeCount(response.total);
          } else if ( actionType == 'multi_add_cart' ) {
            jQuery( document.body ).trigger( 'added_to_cart', [ response.cart_data.fragments, response.cart_data.cart_hash, null ] );
          }
        } else if (response.result == 'exists') {
          alertType = 'info';
        } else {
          title = 'Error';
          alertType = 'error';
          buttons = {};
        }

        //console.log(response);
        showDialog(title, response.message, alertType, buttons);

      }
    });

    function updateEnquiryCartBadgeCount(count) {

      if ( jQuery('.b2b-enquiry-cart-count a').length > 0 ) {
        jQuery('.b2b-enquiry-cart-count a').attr('data-counter', count);
      } else if ( jQuery('.b2b-enquiry-cart-count i').length > 0 ) {
        jQuery('.b2b-enquiry-cart-count i').attr('data-counter', count);
      }
    }

    function showDialog(title, content, alertType, buttons) {

      var alertColor = 'red';

      if (alertType === 'error') {
        alertColor = 'red';
      } else if (alertType === 'info') {
        alertColor = 'blue';
      } else if (alertType === 'success') {
        alertColor = 'green';
      }

      var config = {
        title: title,
        //icon: 'fa fa-info-circle',
        content: content,
        type: alertColor,
        boxWidth: '400px',
        useBootstrap: false,
        animateFromElement: false,
        animation: 'top',
        closeAnimation: 'top'
      };

      if (buttons) {
        config.buttons = buttons;
      }

      jQuery.alert(config);
    }

  }

  function toggleLayout() {
    if (layoutType == CEW_VARIATIONS_TABLE_LAYOUT_BUTTONS_PER_ROW) {
      layoutType = CEW_VARIATIONS_TABLE_LAYOUT_BUTTONS_SINGLE;
    } else {
      layoutType = CEW_VARIATIONS_TABLE_LAYOUT_BUTTONS_PER_ROW;
    }
  }

</script>

<style>

</style>

<div id="variations">
  {#if showFilters}
    <Filters
      bind:searchQuery
      {attributes}
      {activeFilters}
      {textVars}
      on:setFilters={setFilters} />
  {/if}
  <table class="variations">
    <thead>
      <tr>
        {#each columns as column, i}
          {#if column.active === 'on'}
            {#if column.key !== 'attributes' && column.key !== 'quantity'}
              <th
                on:click={() => sortBy(column.key)}
                class:active={sortKey === column.key}
                class={column.key}>
                {column.title}
                <span
                  class="arrow"
                  class:asc={sortOrders[column.key] > 0 || sortKey !== column.key}
                  class:dsc={sortOrders[column.key] < 0 && sortKey === column.key} />
              </th>
            {:else if column.key === 'quantity'}
              <th class={column.key}>{column.title}</th>
            {:else}
              {#each attributes as attr, i}
                {#if attr.visible}
                  <th
                    class={attr.key}
                    on:click={() => sortBy('attribute_' + attr.key)}
                    class:active={sortKey === 'attribute_' + attr.key}>
                    {attr.name}
                    <span
                      class="arrow"
                      class:asc={sortOrders['attribute_' + attr.key] > 0 || sortKey !== 'attribute_' + attr.key}
                      class:dsc={sortOrders['attribute_' + attr.key] < 0 && sortKey === 'attribute_' + attr.key} />
                  </th>
                {/if}
              {/each}
            {/if}
          {/if}
        {/each}
        <!-- <th class="add-to-cart" /> -->
      </tr>
    </thead>
    <tbody>
      {#each filteredData as entry (entry.variation_id)}
        <Variation
          item={entry}
          {columns}
          {attributes}
          productImageURL={imageURL}
          {showSpinner}
          {defaultInputQty}
          {layoutType}
          {showAddToCart}
          {showAddToEnquiry}
          {textVars} />
      {/each}
      {#if !filteredData || !filteredData.length}
        <tr>
          <td colspan={activeColumnsNum} style="text-align: center;">
            {textVars.noResultsText}
          </td>
        </tr>
      {/if}
    </tbody>
  </table>
    {#if layoutType == CEW_VARIATIONS_TABLE_LAYOUT_BUTTONS_SINGLE}
        {#if showAddToCart}
            <button
                    bind:this={multiAddToCartBtn}
                    on:click|preventDefault={multiAddToCart}
                    type="submit"
                    class="button group-add-to-cart alt attribute-table"
                    class:added
                    class:loading="{loadingCart == true}"
            >
                {textVars.addToCartText}
                {#if loadingCart && showSpinner === "on"}
                    <Spinner />
                {/if}
                {#if !loadingCart && added && showSpinner === "on"}
                    <TickIcon />
                {/if}
            </button>
        {/if}
        {#if showAddToEnquiry}
            <button
                    class="group-add-enquiry-button-attr button attribute-table"
                    class:added
                    class:loading="{loadingEnquiry == true}"
                    on:click|preventDefault={multiAddToEnquiry}
            >
                {textVars.addToEnquiryText}
                {#if loadingEnquiry && showSpinner === "on"}
                    <Spinner />
                {/if}
                {#if !loadingEnquiry && added && showSpinner === "on"}
                    <TickIcon />
                {/if}
            </button>
        {/if}
    {/if}
    {#if showTestBtn}
    <button on:click|preventDefault={toggleLayout}>
        [TESTING] Toggle Layout
    </button>
    {/if}
</div>
